import Swiper from 'swiper';
import 'swiper/css';

document.querySelectorAll('.swiper-partners').forEach((container) => {
  new Swiper(container, {
    slidesPerView: 2,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-navigation .swiper-button-next',
      prevEl: '.swiper-navigation .swiper-button-prev',
    },
    breakpoints: {
      460: { slidesPerView: 3 },
      680: { slidesPerView: 4 },
      1000: { slidesPerView: 6 },
    },
  });
});
